import {Component, inject, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConceptDialogData} from '../../core/concept.service';
import {KulturNavParams} from '../../core/definitions/kultur-nav/kultur-nav-params';

@Component({
    selector: 'app-kultur-nav-importer-dialog',
    templateUrl: './kultur-nav-importer-dialog.component.html',
    styleUrls: ['./kultur-nav-importer-dialog.component.scss'],
    standalone: false
})
export class KulturNavImporterDialogComponent implements OnInit {
  // Injections
  public data: ConceptDialogData = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<KulturNavImporterDialogComponent> = inject(MatDialogRef);

  kulturNavData: KulturNavParams;

  ngOnInit(): void {
    this.kulturNavData = {
      entity_type: this.data.conceptType.kulturnav_params.entity_type,
      concept_type_id: this.data.conceptType.concept_type_id,
      sub_type_headline: this.data.conceptType.kulturnav_params.sub_type_headline,
      sub_type: this.data.conceptType.kulturnav_params.sub_type,
      phrase: '',
      multi_import: true
    } as KulturNavParams;
  }

}
